import { generateApiRoute } from '@klp/core/api/helpers';

const kontraktApiName = 'kontrakt';

export const kontraktApiRoutes = {
    listBygg: (byggNummer: string) =>
        generateApiRoute([kontraktApiName, 'byggnummer', byggNummer]),
    listKundeBygg: (kundeNummer: string, byggNummer: string) =>
        generateApiRoute([
            kontraktApiName,
            'kundenummer',
            kundeNummer,
            'byggnummer',
            byggNummer,
        ]),
};
